module.exports = __webpack_public_path__ + "static/media/prayer.4eab8d24.svg";